// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  // TOPページの処理
  // スマホメニューの処理
  document.addEventListener('DOMContentLoaded', function () {
    const spMenuBtn = document.getElementById('js-spMenu')
    const mdSide = document.getElementById('js-mdSide')
    const topSpMenuBg = document.getElementById('js-topSpMenuBg')
    const body = document.body
    const sideLinks = document.querySelectorAll('.mdSide__link')

    // メニューの開閉処理
    function toggleMenu(isActive) {
      spMenuBtn.classList.toggle('is_active', isActive)
      mdSide.classList.toggle('is_active', isActive)
      if (topSpMenuBg) {
        topSpMenuBg.classList.toggle('is_active', isActive)
      }

      body.style.overflow = isActive ? 'hidden' : ''
    }

    // ハンバーガーボタン押下時
    spMenuBtn.addEventListener('click', function () {
      const isActive = !spMenuBtn.classList.contains('is_active')
      toggleMenu(isActive)
    })

    // 各リンク押下時 → メニューを閉じる
    sideLinks.forEach((link) => {
      link.addEventListener('click', function () {
        toggleMenu(false)
      })
    })
  })

  // サイドメニューの処理
  document.addEventListener('DOMContentLoaded', function () {
    const mdSide = document.getElementById('js-mdSide')
    const topMv = document.querySelector('.topMv__images')
    const topEntry = document.querySelector('.topEntry')
    const footer = document.querySelector('.footer')

    if (!mdSide) return

    const state = {
      topMvVisible: false,
      topEntryVisible: false,
      footerVisible: false,
    }

    function updateClass() {
      // いずれかが表示されている → is_openを外す
      const anyVisible = state.topMvVisible || state.topEntryVisible || state.footerVisible
      mdSide.classList.toggle('is_open', !anyVisible)
    }

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const isVisible = entry.isIntersecting
            if (entry.target === topMv) state.topMvVisible = isVisible
            if (entry.target === topEntry) state.topEntryVisible = isVisible
            if (entry.target === footer) state.footerVisible = isVisible
          })
          updateClass()
        },
        { root: null, threshold: 0 }
      )

      if (topMv) io.observe(topMv)
      if (topEntry) io.observe(topEntry)
      if (footer) io.observe(footer)
    } else {
      function inViewport(el) {
        if (!el) return false
        const r = el.getBoundingClientRect()
        return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight)
      }
      function check() {
        state.topMvVisible = topMv ? inViewport(topMv) : false
        state.topEntryVisible = topEntry ? inViewport(topEntry) : false
        state.footerVisible = footer ? inViewport(footer) : false
        updateClass()
      }
      window.addEventListener('scroll', check, { passive: true })
      window.addEventListener('resize', check)
      check()
    }
  })

  // インタビューの画像が大きくなったり比率が変わる処理
  document.addEventListener('DOMContentLoaded', function () {
    // ① js-topWho_01 → 一度だけ is_zoom を付与
    const target01 = document.querySelector('.js-topWho_01')
    const img01 = document.querySelector('.js-topWhoImg_01')

    if (target01 && img01) {
      const observer01 = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            img01.classList.add('is_zoom')
            observer.disconnect() // 一度発火したら監視終了
          }
        })
      })
      observer01.observe(target01)
    }

    // ② js-topWho_02 → 表示中だけ is_active
    const target02 = document.querySelector('.js-topWho_02')
    const img02 = document.querySelector('.js-topWhoImg_02')

    if (target02 && img02) {
      const observer02 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            img02.classList.add('is_active')
          } else {
            img02.classList.remove('is_active')
          }
        })
      })
      observer02.observe(target02)
    }

    // ③ js-topWho_03 → 表示中だけ is_active
    const target03 = document.querySelector('.js-topWho_03')
    const img03 = document.querySelector('.js-topWhoImg_03')

    if (target03 && img03) {
      const observer03 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            img03.classList.add('is_active')
          } else {
            img03.classList.remove('is_active')
          }
        })
      })
      observer03.observe(target03)
    }
  })

  document.addEventListener('DOMContentLoaded', function () {
    const targets = document.querySelectorAll('.top__titleEn .color_00')

    // --- 基準ラインを取得する関数 ---
    function getBaseLine() {
      // rem の数値が環境でズレる場合があるので確実に数値化
      const htmlStyle = getComputedStyle(document.documentElement)
      const remInPx = parseFloat(htmlStyle.fontSize) || 16

      if (window.innerWidth <= 768) {
        return 8 * remInPx // スマホ時
      } else {
        return 10 * remInPx // PC時
      }
    }

    // --- 表示中の要素に stage を付与 ---
    function updateStageClass() {
      let activeIndex = -1
      const baseLine = getBaseLine()

      // 基準ラインと交差している要素を探す
      targets.forEach((el, i) => {
        const rect = el.getBoundingClientRect()
        // rect.bottom > baseLine がギリギリ false になる対策で +1px 余裕を持たせる
        if (rect.top <= baseLine && rect.bottom > baseLine + 1) {
          activeIndex = i
        }
      })

      // 見つからない場合は直前の要素を対象
      if (activeIndex === -1) {
        const firstRect = targets[0].getBoundingClientRect()
        if (firstRect.top > baseLine) {
          return // まだ最初の要素も来てない
        } else {
          for (let i = 0; i < targets.length; i++) {
            const rect = targets[i].getBoundingClientRect()
            if (rect.top > baseLine) {
              activeIndex = i - 1
              break
            }
          }
          if (activeIndex < 0) return
        }
      }

      const el = targets[activeIndex].closest('.top__titleEn')

      // 他をリセット
      document.querySelectorAll('.top__titleEn').forEach((other) => {
        if (other !== el) {
          other.classList.remove('stage1', 'stage2', 'stage3', 'stage4', 'stage4-restored')
          const parent = other.closest('.top__title')
          if (parent) parent.classList.remove('stage4')
        }
      })

      // 基準ラインにいるかどうか
      const rect = targets[activeIndex].getBoundingClientRect()
      if (rect.top <= baseLine && rect.bottom > baseLine + 1) {
        // --- 基準ライン上にいるときは必ず再アニメーション ---
        if (!el.classList.contains('stage1')) {
          el.classList.remove('stage2', 'stage3', 'stage4', 'stage4-restored')
          const parent = el.closest('.top__title')
          if (parent) parent.classList.remove('stage4')

          el.classList.add('stage1')

          setTimeout(() => {
            if (el.classList.contains('stage1')) el.classList.replace('stage1', 'stage2')
          }, 50)

          setTimeout(() => {
            if (el.classList.contains('stage2')) el.classList.replace('stage2', 'stage3')
          }, 1000)

          setTimeout(() => {
            if (el.classList.contains('stage3')) {
              el.classList.replace('stage3', 'stage4')
              const parent = el.closest('.top__title')
              if (parent) parent.classList.add('stage4')
            }
          }, 1500)
        }
      } else {
        // --- 基準ラインから外れた場合 → stage4 を復元 ---
        if (!el.classList.contains('stage4')) {
          el.classList.remove('stage1', 'stage2', 'stage3')
          el.classList.add('stage4', 'stage4-restored')
          const parent = el.closest('.top__title')
          if (parent) parent.classList.add('stage4')
        }
      }
    }

    // --- イベント設定 ---
    let resizeTimer
    window.addEventListener('scroll', updateStageClass, { passive: true })
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        updateStageClass()
      }, 300) // 少し短縮
    })

    // iOS Safari 対策: DOM構築後に 1フレーム待って初回実行
    requestAnimationFrame(updateStageClass)
  })

  // Who等のアニメーション
  document.addEventListener('DOMContentLoaded', function () {
    const targets = document.querySelectorAll('.topEntry__titleEn')

    // 発火済みフラグ
    const triggered = new WeakSet()

    function updateEntryStage() {
      const viewportCenter = window.innerHeight / 2

      targets.forEach((el) => {
        if (triggered.has(el)) return // すでに発火済みなら何もしない

        const rect = el.getBoundingClientRect()
        if (rect.top <= viewportCenter && rect.bottom >= viewportCenter) {
          // stage1からスタート
          el.classList.add('stage1')
          triggered.add(el) // フラグをつけて以降リセットされない

          setTimeout(() => {
            if (el.classList.contains('stage1')) el.classList.replace('stage1', 'stage2')
          }, 50)

          setTimeout(() => {
            if (el.classList.contains('stage2')) el.classList.replace('stage2', 'stage3')
          }, 1000)

          setTimeout(() => {
            if (el.classList.contains('stage3')) {
              el.classList.replace('stage3', 'stage4')
              const parent = el.closest('.topEntry__title')
              if (parent) parent.classList.add('stage4')
            }
          }, 1500)
        }
      })
    }

    // イベント設定
    window.addEventListener('scroll', updateEntryStage)
    window.addEventListener('resize', updateEntryStage)
    updateEntryStage() // 初回ロード時
  })






// 動画のサムネイル
document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById('topVideo');
  const btn = document.querySelector('.js-movieBtn');
  let hasPlayed = false; // 一度でも再生されたかどうか

  // ボタンをクリックしたら再生
  btn.addEventListener('click', function() {
    if (video.paused) {
      video.play();
      btn.classList.add('is_close');
      hasPlayed = true; // フラグを立てる
    } else {
      video.pause();
      // hasPlayed が true なら is_close を外さない
      if (!hasPlayed) {
        btn.classList.remove('is_close');
      }
    }
  });

  // 動画が再生開始されたとき
  video.addEventListener('play', function() {
    btn.classList.add('is_close');
    hasPlayed = true;
  });

  // 動画が停止しても is_close を外さない
});
}
